export default "/static/consultation/doctor.png"